export default __webpack_public_path__ + "static/media/846.d3f8d21d.png";